export enum Permissions {
  ChangeEmail = 'changeEmail',
  ChangePassword = 'changePassword',
  ChangePermissions = 'userManagementChangePermissions',
  ChangeProfileName = 'changeProfileName',
  CreateAccessKeys = 'createAccessKeys',
  EditAccessKeys = 'editAccessKeys',
  EditEntitlements = 'editEntitlements',
  EditProfile = 'editProfile',
  MergeProfile = 'mergeProfile',
  MergeProfileWithCandidateIds = 'mergeProfileWithCandidateIds',
  ChangePearsonVueAndComptiaIds = 'changePearsonVueAndComptiaIds',
  EditAnnouncements = 'editAnnouncements',
  ChangeSuspensions = 'changeSuspensions',
  ConsentManagement = 'consentManagement',
}

export const PermissionLabelMap = {
  [Permissions.ChangeEmail]: 'Change Email',
  [Permissions.ChangePassword]: 'Change Password',
  [Permissions.ChangePermissions]: 'Change Permissions',
  [Permissions.ChangeProfileName]: 'Change Profile Name',
  [Permissions.CreateAccessKeys]: 'Create Access Keys',
  [Permissions.EditAccessKeys]: 'Edit Access Keys',
  [Permissions.EditEntitlements]: 'Edit Entitlements',
  [Permissions.EditProfile]: 'Edit Profile',
  [Permissions.MergeProfile]: 'Merge Profiles',
  [Permissions.MergeProfileWithCandidateIds]:
    'Merge Profiles with Candidate IDs',
  [Permissions.ChangePearsonVueAndComptiaIds]:
    'Change PearsonVue and Candidate IDs',
  [Permissions.EditAnnouncements]: 'Manage Announcements',
  [Permissions.ChangeSuspensions]: 'Change Suspensions',
  [Permissions.ConsentManagement]: 'Manage Consent',
};

export interface IAccount {
  displayName: string;
  email: string;
  id: string;
  permissions: Record<Permissions, boolean>;
  permissionsCount: number;
}
